<template>
  <div id="base-filter-frequency">
    <button
      v-if="isFrequencyFilterSelected"
      type="button"
      class="clear-button-filter"
      @click="clearFilter()"
    >
      clear filters
    </button>
    <button
      type="button"
      class="button-filter"
      :class="filterButtonClass"
      @click="filterExpanded = !filterExpanded"
    >
      <!-- <img :src="filterButtonIcon" /> -->
      <component :is="filterButtonIcon" />
    </button>
    <div class="button-list" :class="filterButtonClass">
      <div class="button-list__inner" :class="filterButtonClass">
        <ul>
          <li v-for="frequency in frequencyModel" :key="frequency.id">
            <button
              type="button"
              :class="activeQueryClass(frequency) ? 'active' : ''"
              @click="pushRouterQuery(frequency)"
            >
              {{ frequency.name }}
            </button>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import frequencyModel from '../../router/frequencyModel';
import FilterIcon from '@/components/svg/FilterIcon.vue';
import FilterIconClose from '@/components/svg/FilterIconClose.vue';
export default {
  name: 'BaseFilterFrequency',
  components: {
    FilterIcon,
    FilterIconClose
  },
  data: () => ({
    filterExpanded: false,
    frequencyModel: frequencyModel,
  }),

  computed: {
    filterButtonIcon() {
      return this.filterExpanded ? FilterIconClose : FilterIcon;
    },
    filterButtonClass() {
      return this.filterExpanded ? 'expanded' : '';
    },
    isFrequencyFilterSelected() {
      return this.$route.params.hasOwnProperty('frequency');
    }
  },
  methods: {
    pushRouterQuery(frequency) {
      const isCurrentRoute = this.activeQueryClass(frequency);
      if (!isCurrentRoute) {
        if (!Object.keys(this.$route.params).length > 0) {
          this.$router.push({
            name: 'ResidentsFrequency',
            params: { id: 'all', frequency: frequency.path }
          });
        } else {
          this.$router.push({ name: 'ResidentsFrequency', params: { frequency: frequency.path } });
        }
      } else {
        this.removeFrequencyParams();
      }
    },
    clearFilter() {
      this.removeFrequencyParams();
    },
    removeFrequencyParams() {
      this.$router.push({
        name: this.$route.matched[this.$route.matched.length - 2].name,
        params: { id: this.$route.params.id }
      });
    },
    activeQueryClass(frequency) {
      return this.$route.params.frequency == frequency.path;
    }
  }
};
</script>
<style scoped lang="scss">
@import '@/assets/sass/components/_base-filter-frequency.scss';
</style>
